import { PureComponent, PropsWithChildren } from "react";

export default class ExtrasFilterAdvancedFilterLabel extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-extras-filter__adv-filter-label">
        {this.props.children}
      </div>
    );
  }
}
